import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { history } from '../../../_helpers';

import { userActions } from '../../../_actions';
import CardBlockComponent from './_components/Card.block';

import './Validate.signup.scss';

class ValidateContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cid: "",
      valid: true,
      submitted: false,
      validated: true
    }
  }

  componentDidMount() {
    document.title = "Validação de Conta - Cellit.io";

    let query = queryString.parse(this.props.location.search);

    if ( !query.cid ) {
      return this.setState({valid: false});
    }

    let self = this;
    this.setState({
      cid: query.cid,
      valid: true
    }, () => {
      self.handleUserValidation();
    });
  }

  handleUserValidation() {
    const { dispatch } = this.props;

    const obj = {
      "user": {
        "cid": this.state.cid
      }
    }

    dispatch(userActions.validateUser(obj)).then(res => {
      if ( res.type !== "USER_VALIDATE_SUCCESS" ) return this.setState({validated: false});

      return history.push({
        pathname: '/signin',
        state: {
          userValidationComplete: true
        }
      });
    });
  }

  render() {
    return (
      <div className="wrapper">
        <div className="validate-signup">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                {
                  !this.state.validated ?
                    this.state.valid ?
                      <CardBlockComponent valid={this.state.valid} />
                    : <CardBlockComponent valid={this.state.valid} />
                  : null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { signUp } = state.signupReducer;
  return signUp;
}

const ConnectedValidateContainer = connect(mapStateToProps)(ValidateContainer);
export { ConnectedValidateContainer as ValidateContainer }